import fetchRequest from '../common/fetchRequest';

export default function fetchReferences (url, method = 'GET', settings) {
    return fetchRequest(url, {
        method,
        data: method !== 'GET'
            ? JSON.stringify(settings)
            : null,
    });
}



// WEBPACK FOOTER //
// ./src/scripts/components/references/fetchReferences.js